export function median(arr: number[]): number | undefined {
    if (!arr.length) {
        return undefined
    }

    const s = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(s.length / 2);

    return s.length % 2 ? s[mid] : ((s[mid - 1] + s[mid]) / 2);
};